import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaisedancabs() {



  const cardData =
  {
    keyword: ' Pune to Mumbai Sedan Cab',
    heading: 'Sai Trupti Cabs: Pune to Mumbai Sedan Cab',
    headingDescription: 'Sai Trupti Cabs offers affordable and comfortable Pune to Mumbai Sedan cab services, ensuring a smooth and safe travel experience for individuals, couples, and business travelers. Our fleet of clean, air-conditioned Sedans such as Dzire, Etios, and Amaze provides excellent mileage, cozy seating, and a relaxing ride throughout the journey. Whether you’re traveling to Mumbai city, Navi Mumbai, or Mumbai Airport, our professional and background-verified chauffeurs guarantee punctual pickups, courteous service, and safe driving at all times. With transparent one-way fares, easy online booking, and 24×7 customer support, Sai Trupti Cabs makes intercity travel simple, reliable, and budget-friendly. Enjoy a comfortable and worry-free Pune to Mumbai trip with Sai Trupti Cabs — your dependable partner for Sedan cab services.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pune to Mumbai Sedan Cab",
    "description": "Pune to Mumbai Sedan Cab provides comfortable, spacious, and air-conditioned travel with premium sedans. Ideal for business travelers, couples, and small groups, this service offers professional drivers, door-to-door pickups, online booking, transparent fares, real-time ride tracking, 24/7 customer support, and smooth intercity travel between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Sedan Taxi",
    "description": "Pune to Mumbai Sedan Taxi ensures hassle-free travel with well-maintained sedans and professional chauffeurs. Passengers enjoy air-conditioned comfort, spacious seating, punctual pickups, online booking, transparent pricing, and 24/7 support for one-way trips, round trips, or airport transfers."
  },
  {
    "name": "Pune to Mumbai Sedan Car Hire",
    "description": "Pune to Mumbai Sedan Car Hire offers flexible rental options for both self-drive and chauffeur-driven trips. Features include air-conditioned comfort, professional drivers, spacious interiors, transparent fares, online booking, and 24/7 support for convenient and reliable intercity travel."
  },
  {
    "name": "Pune to Mumbai Sedan One Way Cab",
    "description": "Pune to Mumbai Sedan One Way Cab provides economical and convenient one-way travel solutions. The service includes spacious sedans, air-conditioned comfort, professional drivers, transparent fares, online booking, real-time ride tracking, and hassle-free travel for families, business travelers, or solo passengers."
  },
  {
    "name": "Pune to Mumbai Sedan Drop",
    "description": "Pune to Mumbai Sedan Drop offers reliable door-to-door drop services with timely pickups, air-conditioned sedans, professional chauffeurs, transparent pricing, online booking, and 24/7 customer support, ensuring stress-free travel for airport transfers, outstation trips, or personal journeys."
  },
  {
    "name": "Pune to Mumbai Sedan Rental",
    "description": "Pune to Mumbai Sedan Rental provides flexible options for renting premium sedans for intercity travel. Passengers benefit from air-conditioned interiors, comfortable seating, professional drivers, transparent fares, online booking, and 24/7 assistance for a seamless travel experience."
  },
  {
    "name": "Pune to Mumbai Sedan AC Cab",
    "description": "Pune to Mumbai Sedan AC Cab ensures fully air-conditioned rides with spacious interiors, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 support for comfortable and convenient Pune-Mumbai travel."
  },
  {
    "name": "Pune to Mumbai Sedan Luxury Cab",
    "description": "Pune to Mumbai Sedan Luxury Cab offers a premium travel experience with plush seating, air-conditioned comfort, professional chauffeurs, transparent pricing, online booking, real-time ride tracking, 24/7 support, and smooth, safe, and elegant intercity travel."
  },
  {
    "name": "Pune to Mumbai Sedan Outstation Cab",
    "description": "Pune to Mumbai Sedan Outstation Cab is perfect for long-distance journeys, offering air-conditioned comfort, spacious interiors, professional drivers, transparent fares, online booking, real-time ride updates, and 24/7 customer support for outstation or intercity trips."
  },
  {
    "name": "Affordable Pune to Mumbai Sedan Cab",
    "description": "Affordable Pune to Mumbai Sedan Cab provides cost-effective travel without compromising on comfort. Passengers enjoy spacious seating, air-conditioned interiors, professional drivers, transparent fares, online booking, 24/7 support, and flexible options for families, groups, or business travel."
  },
  {
    "name": "Pune to Mumbai Sedan Online Booking",
    "description": "Pune to Mumbai Sedan Online Booking allows passengers to reserve sedans conveniently via an online platform. Features include instant confirmation, multiple vehicle options, transparent pricing, real-time ride tracking, 24/7 customer support, and easy management of bookings for smooth intercity travel."
  },
  {
    "name": "Pune to Mumbai Sedan Car Service",
    "description": "Pune to Mumbai Sedan Car Service offers professional and reliable travel solutions, including one-way trips, round trips, airport transfers, and outstation journeys. Features include spacious seating, air-conditioned comfort, experienced drivers, transparent fares, online booking, real-time ride tracking, and 24/7 support."
  },
  {
    "name": "Pune to Mumbai Sedan Airport Taxi",
    "description": "Pune to Mumbai Sedan Airport Taxi provides dedicated airport transfers with timely pickups, air-conditioned sedans, professional chauffeurs, transparent pricing, online booking, real-time ride tracking, and 24/7 support, ensuring hassle-free travel to and from Mumbai airports."
  },
  {
    "name": "Pune to Mumbai Sedan Travel Service",
    "description": "Pune to Mumbai Sedan Travel Service offers comprehensive intercity travel options, including one-way trips, round trips, airport transfers, and outstation journeys. Passengers enjoy air-conditioned comfort, spacious interiors, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 customer support."
  },
  {
    "name": "Pune to Mumbai Sedan Hire Near Me",
    "description": "Pune to Mumbai Sedan Hire Near Me provides easy access to nearby sedan rental services for intercity travel. Passengers benefit from air-conditioned comfort, spacious seating, professional chauffeurs, online booking, transparent fares, real-time ride tracking, and 24/7 support for convenient travel."
  }
],
"tableData": [
  ["Pune to Mumbai Sedan Cab", "Pune to Mumbai Sedan Taxi"],
  ["Pune to Mumbai Sedan Car Hire", "Pune to Mumbai Sedan One Way Cab"],
  ["Pune to Mumbai Sedan Drop", "Pune to Mumbai Sedan Rental"],
  ["Pune to Mumbai Sedan AC Cab", "Pune to Mumbai Sedan Luxury Cab"],
  ["Pune to Mumbai Sedan Outstation Cab", "Affordable Pune to Mumbai Sedan Cab"],
  ["Pune to Mumbai Sedan Online Booking", "Pune to Mumbai Sedan Car Service"],
  ["Pune to Mumbai Sedan Airport Taxi", "Pune to Mumbai Sedan Travel Service"],
  ["Pune to Mumbai Sedan Hire Near Me", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Sedan Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable sedan cab services from Pune to Mumbai—ideal for solo travellers or small groups seeking a smooth one‑way trip."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Fare",
    "WhyChoosedescription": "We offer clear one‑way fare estimates for sedan cars on the Pune‑to‑Mumbai route (starting around ₹1,600–₹2,500), inclusive of driver and major costs. :contentReference[oaicite:0]{index=0}"
  },
  {
    "WhyChooseheading": "Wide Range of Sedan Options",
    "WhyChoosedescription": "Choose from comfortable sedan models like the Maruti Dzire, Toyota Etios or similar, designed for a relaxed drive between Pune and Mumbai. :contentReference[oaicite:1]{index=1}"
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous, trained drivers are familiar with the Pune–Mumbai highway, know ideal routes, and ensure your journey is safe, on‑time and smooth."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pick‑up anywhere in Pune (including suburbs) and drop‑off across Mumbai—including airports, railway stations or city‑locations—using our sedan service."
  },
  {
    "WhyChooseheading": "Clean & Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our sedans on the Pune–Mumbai route are regularly serviced, sanitized, and outfitted for long‑distance comfort so you can sit back and relax."
  },
  {
    "WhyChooseheading": "24/7 Booking & Support",
    "WhyChoosedescription": "Our support team is available round‑the‑clock to assist with booking, queries or changes for your Pune to Mumbai sedan cab."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your sedan cab from Pune to Mumbai easily via call, WhatsApp or our website, with instant confirmation and prompt dispatch."
  }
]
































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Mumbai Sedan cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and comfortable Pune to Mumbai Sedan cab services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Pune to Mumbai Sedan cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Mumbai Sedan cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of Sedan cabs are available for Pune to Mumbai trips?',
    answer: 'We offer a variety of Sedan cabs including Toyota Etios, Honda City, Maruti Ciaz, and other comfortable and well-maintained cars for your journey.',
  },
  {
    question: 'Are the drivers experienced for Pune to Mumbai Sedan cab trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Pune–Mumbai Expressway, ensuring a safe and smooth ride.',
  },
  {
    question: 'Can I book a Sedan cab for corporate or airport transfers between Pune and Mumbai?',
    answer: 'Certainly. Our Sedan cab services cater to corporate travel, airport pickups, and personal trips between Pune and Mumbai.',
  },
  {
    question: 'Is the Pune to Mumbai Sedan cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Sedan cab services between Pune and Mumbai for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to Mumbai Sedan cab fares?',
    answer: 'Our Sedan cab fares start from ₹2,000 for a one-way Pune to Mumbai trip, depending on the vehicle type, pickup location, and timing.',
  },
  {
    question: 'What payment options are accepted for Pune to Mumbai Sedan cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free and secure transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Mumbai Sedan cabs?',
    answer: 'All Sedan cabs are sanitized before every trip, and our drivers follow strict hygiene and safety measures for a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Mumbai Sedan cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Mumbai Sedan cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Desai',
    feedback: 'I booked a Pune to Mumbai Sedan cab with Sai Trupti Cabs. The ride was smooth and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rutuja Patil',
    feedback: 'Sai Trupti Cabs provided excellent Pune to Mumbai Sedan cab service. Comfortable car and hassle-free journey.',
    rating: 5,
  },
];



























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Sedan Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-sedan-cab.jpg",
  "description": "Book Pune to Mumbai Sedan Cab with Sai Trupti Cabs for a smooth, safe, and affordable ride. Perfect for one-way trips, airport transfers, or outstation travel. Enjoy AC comfort, verified drivers, and 24/7 online booking for Pune to Mumbai Sedan rides.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "15020"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-sedan-cab"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai Sedan Cab | Smooth & Affordable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Sedan Cab with Sai Trupti Cabs for a smooth, safe, and affordable ride. Perfect for one-way trips, airport transfers, or outstation travel. Enjoy AC comfort, verified drivers, and 24/7 online booking for Pune to Mumbai Sedan rides." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Sedan Cab, Pune to Mumbai Sedan Taxi, Pune to Mumbai Sedan Car Hire, Pune to Mumbai Sedan One Way Cab, Pune to Mumbai Sedan Drop, Pune to Mumbai Sedan Rental, Pune to Mumbai Sedan AC Cab, Pune to Mumbai Sedan Luxury Cab, Pune to Mumbai Sedan Outstation Cab, Affordable Pune to Mumbai Sedan Cab, Pune to Mumbai Sedan Online Booking, Pune to Mumbai Sedan Car Service, Pune to Mumbai Sedan Airport Taxi, Pune to Mumbai Sedan Travel Service, Pune to Mumbai Sedan Hire Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaisedancabs;